import ServiceTemplate from '@/components/ServiceTemplate';

export default function DueDiligence() {
  const data = {
    title: 'Due Diligence Services',
    subtitle: 'Comprehensive due diligence for business transactions and investments.',
    overviewTitle: 'Why Due Diligence is Critical',
    overviewImage: 'https://images.unsplash.com/photo-1638202947561-e372255007b3',
    description: [
      'Due diligence is essential before business acquisitions, investments, or major transactions. Thorough investigation reveals risks, validates claims, and informs decision-making to prevent costly mistakes.',
      'Our due diligence service provides comprehensive review of financial, legal, operational, and commercial aspects of target companies, delivering detailed reports to support informed decisions.',
      'We identify red flags, quantify risks, and provide strategic recommendations to help you negotiate better terms or walk away from problematic transactions.'
    ],
    benefits: [
      { title: 'Risk Identification', description: 'Uncover hidden risks and liabilities.' },
      { title: 'Informed Decisions', description: 'Make decisions based on complete information.' },
      { title: 'Negotiation Leverage', description: 'Use findings to negotiate better terms.' },
      { title: 'Comprehensive Review', description: 'Financial, legal, and operational analysis.' },
      { title: 'Expert Analysis', description: 'Professional evaluation and recommendations.' },
      { title: 'Detailed Reporting', description: 'Complete due diligence reports.' }
    ],
    process: [
      { title: 'Investigation & Analysis', description: 'Comprehensive review and analysis of all relevant legal, financial, and operational factors.' },
      { title: 'Documentation & Recommendations', description: 'Detailed documentation of findings with strategic recommendations for action.' },
      { title: 'Implementation & Support', description: 'Ongoing support for implementation of recommendations and resolution of issues.' }
    ],
    pricing: [
      {
        name: 'Consultation',
        description: 'Initial assessment',
        price: '$299',
        period: 'Per session',
        features: [
          '90-minute consultation',
          'Situation analysis',
          'Strategy recommendations',
          'Action plan',
          'Written summary',
          'Follow-up email support'
        ]
      },
      {
        name: 'Retainer',
        description: 'Ongoing advisory',
        price: '$1,499',
        period: 'Per month',
        featured: true,
        features: [
          'Monthly strategy sessions',
          'Unlimited email support',
          'Priority phone access',
          'Document review',
          'Compliance monitoring',
          'Quarterly reporting',
          'Dedicated attorney'
        ]
      },
      {
        name: 'Project-Based',
        description: 'Custom engagement',
        price: 'Custom',
        period: 'Based on scope',
        features: [
          'Scope-based pricing',
          'Dedicated team',
          'Project management',
          'Milestone deliverables',
          'All work product included',
          'Comprehensive reporting',
          'Executive support'
        ]
      }
    ],
    faqs: [
      { question: 'What does due diligence cover?', answer: 'Typical due diligence includes financial statements, legal documents, contracts, intellectual property, operations, customers, employees, and regulatory compliance.' },
      { question: 'How long does due diligence take?', answer: 'Duration varies from 2-8 weeks depending on transaction complexity, company size, and level of investigation required.' },
      { question: 'When should due diligence start?', answer: 'Due diligence typically begins after letter of intent execution and runs until closing, with findings potentially affecting final terms.' },
      { question: 'What is financial due diligence?', answer: 'Financial DD reviews historical financials, accounting practices, revenue quality, working capital, and financial projections to assess financial health.' },
      { question: 'What about legal due diligence?', answer: 'Legal DD examines corporate structure, contracts, litigation, regulatory compliance, intellectual property, and potential liabilities.' },
      { question: 'Can due diligence uncover fraud?', answer: 'While not guaranteed, thorough due diligence often reveals inconsistencies, misrepresentations, or fraudulent activities.' },
      { question: 'What if problems are found?', answer: 'Findings can lead to price adjustments, additional seller representations, escrows, or deal termination depending on severity.' },
      { question: 'Is due diligence confidential?', answer: 'Yes, due diligence is conducted under confidentiality agreements to protect sensitive business information.' }
    ]
  };

  return <ServiceTemplate {...data} />;
}
